export default (context:any, payload:any) => {
    const targetState = context.rootState[payload.targetId];
    const validity = { ...targetState.validity };

    if (targetState.min) {
        validity.lessThanMin = Number(targetState.value) < Number(targetState.min);
    }

    context.commit('setAttribute', {
        id: payload.targetId,
        attribute: 'validity',
        value: validity,
    }, {
        root: true,
    });

    return validity;
};